exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qrCode {\n  color: #1890ff;\n  font-size: 14px;\n}\n.el-table .highlight {\n  background: #528591;\n  color: #fff;\n}\n.returnStyle {\n  color: red !important;\n}\n.top {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.operate {\n  color: #1890ff;\n  font-size: 14px;\n  margin: 0 20px;\n  cursor: pointer;\n}\n.warn {\n  color: #fff;\n}\n.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {\n  background: rgba(245, 247, 250, 0.1);\n}\n", ""]);

// exports
